import axios, { AxiosInstance, AxiosResponse } from 'axios';

export const client: AxiosInstance = axios.create({
  baseURL: 'https://cookdtv.com',
  headers: {
    'Content-Type': 'application/json'
  }
});

client.interceptors.response.use(
  function(response: AxiosResponse) {
    return response.data;
  },
  function(error: any) {
    return Promise.reject(error);
  }
);
